export const clearFields = (form) => {

    // KAMIENIE MILOWE

    const etapy = [
        'inicjacja_zadania_list',
        'przygotowania_zadania_list',
        'realizacja_zadania_list',
        'zamykania_zadania_list',
    ]

    const newForm = { ...form };

    etapy.forEach(nazwaListy => {
        if (Array.isArray(newForm[nazwaListy])) {
            newForm[nazwaListy] = newForm[nazwaListy].map((item) => {
                if (item.czy_kamien_milowy !== 'Tak') {
                    return item;
                }

                const newItem = { ...item };

                delete newItem.data_rozpoczecia;
                delete newItem.budzet_planowany;

                return newItem;
            });
        }
    });

    return newForm;
}

export class CLEAR_PH {
    dane(form) {
        form = clearFields(form)
        return form
    }
}